import axios from "axios";
import {store} from "../store";
import {updateWithRefreshToken} from "../store/auth/Slice";
import {logOut} from "../store/auth/ActionCreators";

export const API_DRIVER = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    responseType: "json",
    headers: {
        "Content-Type": "application/json",
    }
})

API_DRIVER.interceptors.request.use(
    config => {
        if (config.headers) {
            config.headers["x-lang"] = store.getState().appReducer.language
            const token = store.getState().authReducer.loggedInUser.access_token
            if (token.length) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
        return config;
    },
    error => Promise.reject(error)
);

API_DRIVER.interceptors.response.use(
    response => {
        const xToken = response.headers['x-token']
        if (typeof xToken === 'string') {
            store.dispatch(updateWithRefreshToken(xToken))
        }
        const contentType = response.headers['content-type']
        if (typeof contentType === 'string' && contentType.includes('text/html')) {
            return Promise.reject({response: {data: 'HTML returned from web server'}})
        }
        return response
    },
    error => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
            store.dispatch(logOut(false))
        }
        if (error?.response?.data) {
            console.error(error.response.data)
        }
        return Promise.reject(error);
    }
);
